// extracted by mini-css-extract-plugin
export default {"removeButton":"RemoveButton_removeButton__jHBsT"};